<template>
  <div v-if="products.length > 0" class="product__grid step__grid">
    <div class="step__head">
      <div class="info__block">
        <p class="title">Product Grid</p>
        <p class="subtitle">Listing your <span>{{filProducts.length}} products</span>  containing <span>{{numGheoms}} Gheoms</span> </p>
      </div>
      <div class="actions__block">
        <div class="filters__type">
          <GheomCheckboxes
            @changegroup="onChangeGroup"
            :options="checkoptions"
            :config="checkconfig">
          </GheomCheckboxes>
        </div>
        <div class="searcher">

        </div>
      </div>
    </div>
    <div v-if="hasProducts" class="step__body">
        <div v-for="(product,index) in filProducts" class="" :key="product.id">
          <gheom-card
            :myproduct="product"
            @activatetooltip="onTooltipActivation"
            v-if="(product.name != 'No product provided') && (product.name != 'Producto no registrado')"
            v-on:click.native="loadProduct(index)">
          </gheom-card>
          <orphan-card
            v-else
            :orphans="product"
            v-on:click.native="loadProduct(index)">
          </orphan-card>
       </div>
    </div>
  </div>
  <div v-else class="products--zero-view">
    <img src="/images/zero.svg" alt="">
    <p class="title">No Gheoms</p>
    <p class="subtitle">You have not tested any product yet in this crop</p>
    <p class="emphatize">Once you test a product it will appear in here</p>
    <a href="#">Request Gheom</a>
  </div>
</template>

<script>
import GheomCheckboxes from './GheomCheckboxes'

export default {
  name: "",
  components: {
    GheomCheckboxes
  },
  props: [
    "products"
  ],
  data:function(){ 
    return {
      checkoptions: [
        {
          "sh": "all",
          "id": "-1",
          "color": "#ffffff",
          "full": "All",
          "is_all": true,
          "is_checked": true
        },
        {
          "sh": "fer",
          "id": "1",
          "color": "#ffffff",
          "full": "Fertilizer",
          "is_all": false,
          "is_checked": true,
        },
        {
          "sh": "phy",
          "id": "2",
          "color": "#ffffff",
          "full": "Phytosanitary",
          "is_all": false,
          "is_checked": true
        },
        {
          "sh": "bio",
          "id": "3",
          "color": "#ffffff",
          "full": "Bioestimulant",
          "is_all": false,
          "is_checked": true
        }
      ],
      checkconfig: {
        "orientation": "h",
        "has_all": true,
        "id": "type_product"
      },
      selected_product: null,
      selected_checks: ["-1"]
    }
  },

  computed: {
    filProducts: function() {
      let result = this.products

      if(this.selected_checks.includes("-1")) {
        return result
      } else {
        if(this.selected_checks.includes("0")) {
          result = []
          return result
        } else {
          result = this.products.map((prod) => {
            if(prod.type_id) {
              if(this.selected_checks.includes(prod.type_id.toString())) {
                return prod;
              } 
            }
          })

          result = result.filter((el) => el != undefined);

          return result
        }
      }
    },

    numGheoms: function() {
      var numG = 0;
      this.filProducts.forEach((prod) => {
        numG = numG + prod.gheoms.length;
      })
      return numG;
    },

    hasProducts: function() {
      var hasprod = false; 
      (this.products.length > 0) ? hasprod = true : hasprod = false;
      return hasprod;
    }, 

    hasOrphans: function() {
      this.products.forEach((prod) => {
        if(prod.name == "No product provided") {
          return true;
        } 
      })

      return false;
    }
  },

  methods: {
    /**
    * LOAD this.gheoms with the GHEOMS of the clicked PRODUCT
    * @param index array_index of the clicked PRODUCT
    */
    loadProduct(index){
      let product = this.products[index];
      if(!product) return;

      this.selected_product = product;
      this.$emit('onproductselected', this.selected_product)
    },

    checkAll(){
      this.checkoptions.forEach((opt) => {
        opt.is_checked = true
      })
      this.selected_checks = ["-1"]
    },

    uncheckAll() {
      this.checkoptions.forEach((opt) => {
        opt.is_checked = false
      })
      this.selected_checks = ["0"]
    },
    
    onChangeGroup(value, item) {
      if(item.is_all) {
        if (value == true) {
          this.checkAll()
        } else {
          this.uncheckAll()
        }
      } else {
        if(value == true) {
          this.checkoptions.forEach((opt) => {
            if(opt.sh == item.sh) {
              opt.is_checked = true;
            }
          })
        } else {
          this.checkoptions.forEach((opt) => {
            if(opt.sh == item.sh) {
              opt.is_checked = false;
            }
          });
          this.checkoptions[0].is_checked = false;
        }

        this.selected_checks = []

        this.checkoptions.forEach((theopt) => {
          if (theopt.is_checked) {
            this.selected_checks.push(theopt.id)
          }
        });

        if (this.selected_checks.length == 0){
          this.selected_checks.push("0")
        }
      }
    },

    onTooltipActivation() {
      console.log("tooltip activation was made")
      this.$emit("manageTooltip");
    }
  }
}
</script>

